import { PharmacyOnDuty } from '@frontend/apb/types';
import { APIClient } from '@frontend/api-utils';

export class APBClient extends APIClient {
    public static readonly endpoint = '/apb-api/v1';

    public static async getPharmacyOnDuty(): Promise<PharmacyOnDuty[]> {
        const response = await this.fetch(`${this.endpoint}/pharmacy-on-duty`);
        return await this.handleResponse<PharmacyOnDuty[]>(response);
    }
}
